import React from 'react';

import {getConfig} from '../../config';


function initializeRootCause() {
    const refScript = document.getElementsByTagName('script')[0];
    const rcScript = document.createElement('script');

    rcScript.async = true;
    rcScript.crossOrigin = 'anonymous';
    rcScript.src = 'https://app.therootcause.io/rootcause-core.js';

    rcScript.addEventListener('load', onRCLoaded);
    refScript.parentNode.insertBefore(rcScript, refScript);

    function onRCLoaded() {
        window.logger = window.RC && new window.RC.Logger({
            applicationId: '17875b52579886999638ae1ffdebfc7855a0928a',
            recordSessionVideo: false,
            captureScreenshot: false,
            recordUserActions: false,
            logConsoleOutput: true,
            logAjaxRequests: true,
            treatFailedAjaxAsError: true,
            logResourceLoadFailures: true,
            showNotificationOnError: false,
            showFeedbackButton: false,
            showErrorDialog: false,
            maxNbrOfReportedErrors: 10,
            version: '', // TODO,
            frameworkVersion: '' // TODO
        });
    }
}


class RootCauseWrapper extends React.PureComponent {

    constructor(props) {
        super(props);

        this.config = getConfig();
    }

    componentDidMount() {
        if (this.config.ENVIRONMENT === 'production') {
            initializeRootCause();
        }
        else {
            console.log('Not loading rootcause because config is ', this.config);
        }
    }

    render() {
        return null;
    }
}

export default RootCauseWrapper;
